import { Slider } from '@mui/material';
import { useRef, useState } from 'react';
import ReactPlayer from 'react-player';
import { sprinkles } from '@design-system/sprinkles.css';
import { Typography } from '@design-system/components/typography/typography';
import { getVideoTimeFormat } from '../../helpers';
import { bgColorsVars } from '@design-system/vars.css';

type VideoThumbnailSelect = {
  videoSrc: string;
  onChange: (timeInSeconds: number) => void;
  onRestore: () => void;
};

export function SelectThumbnailOnUpload(p: VideoThumbnailSelect) {
  const playerRef = useRef<ReactPlayer>(null);
  const [duration, setDuration] = useState(0);
  const [sliderValue, setSliderValue] = useState(0);

  const handleSliderChange = (
    _event: Event | null,
    newValue: number | number[],
  ) => {
    const value = newValue as number;
    setSliderValue(value);
    p.onChange(value);
    if (playerRef?.current) {
      playerRef.current.seekTo(value);
    }
  };

  return (
    <div
      className={sprinkles({
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        gap: 'm',
      })}
    >
      <div
        className={sprinkles({
          borderRadius: 'm',
          display: 'flex',
          justifyContent: 'center',
          bg: 'N-100',
        })}
      >
        <ReactPlayer
          onDuration={(duration) => setDuration(duration)}
          ref={playerRef}
          playing={false}
          seconds={sliderValue}
          playsinline
          height={300}
          url={p.videoSrc}
          style={{
            borderRadius: '6px',
            overflow: 'hidden',
          }}
        />
      </div>
      <Typography variant="body">
        Use slider to select frame for thumbnail.
      </Typography>
      <Typography variant="body" className={sprinkles({ textAlign: 'center' })}>
        {getVideoTimeFormat(sliderValue)}/{getVideoTimeFormat(duration)}
      </Typography>
      <Slider
        value={sliderValue}
        max={duration}
        step={0.01}
        onChange={handleSliderChange}
        sx={{
          '&.MuiSlider-root': {
            borderRadius: 3,
          },
          '&.MuiSlider-root > .MuiSlider-track': {
            color: bgColorsVars['P-80'],
          },
          '&.MuiSlider-root > .MuiSlider-thumb': {
            color: bgColorsVars['P-80'],
          },
        }}
      />
    </div>
  );
}
